import { ArrowUp } from "lucide-react";
import { CONTACT_EMAIL, PLATFORMS, SOCIALS } from "../../data/site";
import { scrollToId } from "./SmoothScroll";

export const Footer = ({ platforms = PLATFORMS, links = {} }) => (
  <footer data-testid="site-footer" className="border-t border-[var(--line)] px-4 pb-8 pt-20 sm:px-8 lg:px-16">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col justify-between gap-10 md:flex-row">
        <div className="flex items-center gap-4">
          <img src="/mae-logo-ink.webp" alt="MAE logo" className="h-20 w-20 rounded-full" />
          <div>
            <p className="font-display text-2xl uppercase">Money Alwayz Entertainment</p>
            <a data-testid="footer-email-link" href={`mailto:${CONTACT_EMAIL}`} className="text-zinc-300 hover:text-[var(--cash)]">{CONTACT_EMAIL}</a>
          </div>
        </div>
        <div className="flex flex-wrap gap-x-6 gap-y-3 font-mono text-xs uppercase tracking-[0.2em]">
          {[...platforms, ...SOCIALS.map((s) => ({ ...s, url: links?.[s.key] ?? "" }))].filter((p) => p.url).map((p) => (
            <a key={p.key} data-testid={`footer-link-${p.key}`} href={p.url} target="_blank" rel="noopener noreferrer" className="text-zinc-300 hover:text-[var(--cash)]">{p.name}</a>
          ))}
          <button data-testid="footer-back-to-top" onClick={() => scrollToId("top")} className="flex items-center gap-2 text-zinc-300 hover:text-[var(--cash)]">Top <ArrowUp size={14} /></button>
        </div>
      </div>
      <p aria-hidden className="mt-16 select-none font-display text-[27vw] uppercase leading-[0.8] text-[var(--ink-3)] lg:text-[22rem]">MAE$</p>
      <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-zinc-400">© {new Date().getFullYear()} Money Alwayz Entertainment. All rights reserved.</p>
    </div>
  </footer>
);
